import React, { lazy } from 'react'
import { ReactComponent as IconNumbers } from '../assets/img/menu/numbers.svg'
import { ReactComponent as IconUsers } from '../assets/img/menu/users.svg'
import oGet from 'lodash/get'
import { EUserMemberType } from '@/utils/user'

const checkAuth = (userStore: any) => {
  // 必须是 Business 及以上版本
  if (
    ![
      EUserMemberType.Business,
      EUserMemberType['Business Pro'],
      EUserMemberType.Enterprise,
      EUserMemberType['Enterprise Pro'],
    ].includes(userStore.userMemberType)
  ) {
    return false
  }
  const isUserGroupMember = oGet(userStore, 'isUserGroupMember', false)
  const isAdminGroupMember = oGet(userStore, 'isAdminGroupMember', false)
  // 不能是普通团队成员
  if (isUserGroupMember && !isAdminGroupMember) {
    return false
  }
  return true
}

const teamRoutes = [
  {
    divider: true,
    name: 'Numbers',
    path: '/page/numbers',
    icon: <IconNumbers />,
    component: lazy(() => import(/* webpackChunkName: 'numbers' */ '../page/numbers')),
    role: checkAuth,
  },
  {
    name: 'Users',
    path: '/page/users',
    icon: <IconUsers />,
    component: lazy(() => import(/* webpackChunkName: 'users' */ '../page/users')),
    role: checkAuth,
  },
]

export default teamRoutes
